import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = ({ onOpenAnamnese }) => {
  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-large fade-in-up">
          Rééquilibrez votre corps,<br />apaisez votre esprit.
        </h1>
        <p className="hero-subtitle fade-in-up delay-1">
          Centre de Hijama (cupping therapy), massages thérapeutiques<br />et soins de bien-être à Mons.
        </p>
        <p className="hero-home-service fade-in-up delay-1">
          ✨ Déplacements à domicile jusqu'à Charleroi
        </p>
        <div className="hero-cta fade-in-up delay-2">
          <button 
            onClick={onOpenAnamnese}
            className="btn-primary"
          >
            Prendre Rendez-vous
            <ArrowRight size={16} style={{ marginLeft: '8px' }} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;